import { render, staticRenderFns } from "./CurrencySwitcher.vue?vue&type=template&id=cd65a39c&"
import script from "./CurrencySwitcher.js?vue&type=script&lang=js&"
export * from "./CurrencySwitcher.js?vue&type=script&lang=js&"
import style0 from "./CurrencySwitcher.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports